import React from 'react';

const AlertsForOfferContext = React.createContext(null);
export const AlertsForOfferProvider = AlertsForOfferContext.Provider;
export default AlertsForOfferContext;